import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { BlueButton, NavButton } from 'components/Button'
import { Description, MainHeadline } from 'components/Typography'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const CouponTemplate: FC = () => {
  const dispatch = useDispatch()
  const goToCouponCreatePage = useCallback(() => dispatch(push('/admin/coupon/create')), [dispatch])
  const goToCouponListPage = useCallback(() => dispatch(push('/admin/coupon/list')), [dispatch])
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'クーポン'} />
      <Spacer size={20} />
      <Description description={'確認したいページをクリックしてください。'} />
      <Spacer size={20} />
      <Description description={'新しくクーポンを登録する場合は、こちらから登録してください。'} fontWeight={'bold'} />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'新しくクーポンを登録する'}
        onClick={goToCouponCreatePage}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <Description
        description={'発行済のクーポンを確認する場合や、ユーザーと紐付ける場合こちらから確認してください。'}
        fontWeight={'bold'}
      />
      <Spacer size={20} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'発行済クーポン一覧'}
        onClick={goToCouponListPage}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default CouponTemplate
